import { atom } from 'recoil'
import {groups, supergroups} from "./metadata";

const findDefault = (list) => {
	const v = list.find((v) => v.default)
	return v ? v : list[0]
}

function generateStyleExpression(data, fieldName) {

// specify fields to match on
    const expression = [
        'match',
        ['get', fieldName]
    ];

    // (value, color) pairs
    data.forEach(item => {
        expression.push(item.id);
        expression.push(item.color);
    });

    // Default color if no match
    expression.push('gray');

    return expression;
}


export const LOAC_LAYERS = [
	{
		default: true,
		label: "Group",
		value: "group",
        fillColor: generateStyleExpression(groups, 'group'),
	},
	{
		label: "Supergroup",
		value: "supergroup",
		fillColor: generateStyleExpression(supergroups, 'supergroup'),
	},
]

export const LOAC_LAYER_DEFAULT = findDefault(LOAC_LAYERS)

export const loacLayerAtom = atom({
  key: "loac-layer-atom",
  default: LOAC_LAYER_DEFAULT,
});